// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"1044":"bdef1783bc9e1e00","2451":"6ea0925f1863338b","6561":"ce75c75d3393476c","9918":"744c2781b515aaa5"}[chunkId] + ".css";
};